/**
 * querySelector wrapper
 *
 * @param {string} selector Selector to query
 * @param {Element} [scope] Optional scope element for the selector
 */
export function qs(selector, scope) {
  return (scope || document).querySelector(selector);
}

export function qsArray (selector, scope) {
  let nodeList = (scope || document).querySelectorAll(selector);
  let arr = [];
  for(let i = 0; i < nodeList.length; i++) {
    arr.push(nodeList[i]);
  }
  return arr;
}

/**
 * addEventListener wrapper
 *
 * @param {Element|Window} target Target Element
 * @param {string} type Event name to bind to
 * @param {Function} callback Event callback
 * @param {boolean} [capture] Capture the event
 */
export function $on(target, type, callback, capture) {
  target.addEventListener(type, callback, !!capture);
}

/**
 * Attach a handler to an event for all elements matching a selector.
 *
 * @param {Element} target Element which the event must bubble to
 * @param {string} selector Selector to match
 * @param {string} type Event name
 * @param {Function} handler Function called when the event bubbles to target
 *                           from an element matching selector
 * @param {boolean} [capture] Capture the event
 */
// export function $delegate(target, selector, type, handler, capture) {
//   const dispatchEvent = event => {
//     const targetElement = event.target;
//     const potentialElements = target.querySelectorAll(selector);
//     let i = potentialElements.length;
//
//     while (i--) {
//       if (potentialElements[i] === targetElement) {
//         handler.call(targetElement, event);
//         break;
//       }
//     }
//   };
//
//   $on(target, type, dispatchEvent, !!capture);
// }

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {Function} func to be executed on debounce
 * @param {number} wait time in milliseconds
 * @param {boolean} immediate boolean
 *
 * */
export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/*!
* Microsoft Internet Explorer Browser Test
* */
export function isInternetExplorer() {
  let ua = window.navigator.userAgent;

  let msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    return true;
    // IE 10 or older => return version number
    // return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    return true;
    // IE 11 => return version number
    // let rv = ua.indexOf('rv:');
    // return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  // other browser
  return false;
}

/*!
 * Microsoft Edge Browser Test
 * */
export function isEdge() {
  let ua = window.navigator.userAgent;

  let edge = ua.indexOf('Edge/');
  if (edge > 0) {
    return true;
    // // Edge (IE 12+) => return version number
    // return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

/*
 * Google Analytic tracking function
 * */

export function trackEvent(category, action, label, value)
{
  ga('send', 'event', category, action, label, value);
  // console.log('event: ' + category + ", " + action + ', ' + label + ', ' + value);
}
